var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFyiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(0%, 59.214783%, 27.058411%)",
    fillOpacity: 1,
    d: "M 21.023438 6 L 2 7.664062 L 2.957031 18.621094 L 21.984375 16.957031 Z M 17.085938 14.875 L 18.550781 14.746094 L 18.027344 8.769531 L 16.5625 8.894531 Z M 11.46875 9.339844 L 12.847656 11.304688 L 13.847656 9.132812 L 15.460938 8.992188 L 13.703125 12.675781 L 13.917969 15.136719 L 12.449219 15.261719 L 12.234375 12.804688 L 9.859375 9.484375 Z M 5.460938 9.90625 L 8.753906 9.617188 L 8.859375 10.796875 L 7.003906 10.960938 L 7.101562 12.117188 L 8.960938 11.953125 L 9.0625 13.128906 L 7.207031 13.289062 L 7.414062 15.679688 L 5.980469 15.804688 Z M 5.460938 9.90625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyiIcon);
export default __webpack_public_path__ + "static/media/fyi_icon.b61806ae0d6c9cb391346187405c1856.svg";
export { ForwardRef as ReactComponent };